import {
    FETCH_REVIEWS, REVIEWS_SUCCESS, REVIEWS_FAIL,
    SUBMIT_REVIEW, SUBMIT_REVIEW_SUCCESS, SUBMIT_REVIEW_FAIL
} from '../actions/index';

const initialState = {
    loading: false,
    submitting: false,
    reviews: [],
    error: null,
};

export const reviewReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REVIEWS:
            return { ...state, loading: true, error: null };
        case REVIEWS_SUCCESS:
            return { ...state, loading: false, reviews: action.payload };
        case REVIEWS_FAIL:
            return { ...state, loading: false, error: action.payload };
        case SUBMIT_REVIEW:
            return { ...state, submitting: true };
        case SUBMIT_REVIEW_SUCCESS:
            return { ...state, submitting: false };
        case SUBMIT_REVIEW_FAIL:
            return { ...state, submitting: false, error: action.payload };
        default:
            return state;
    }
};
